import { IZoneOption } from '../../interface/Zone'

export const defaultZoneOption: Readonly<Required<IZoneOption>> = {
  tipDisabled: true
}
